import React, { FC, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { useTheme, css, keyframes } from 'styled-components';
import { LayoutConst, modalControllerSelector, useModal } from "core/modules";
import {
  FlexBox,
  useIsMobile,
  GridBox,
  useBreakpoint,
  DropdownListItem,
  DropdownTooltip,
  FixedFooterUI,
  FixedFooterCopyRight,
  FixedFooterLegalsItem,
  FixedFooterLegals,
  FixedFooterDropdownLegals,
  NavItemForeign,
  FixedFooterSelectedItem,
  FixedFooterSelectedItemWrapper,
  NavbarLogoName,
  Colors,
  ExternalLink
} from '@brg/ui';
import { AppTester, getCurrentAppName, AppName, getCurrentContextName } from 'supporting';
import ArrowFooterLarge from "../../icons/ArrowFooterLarge";
import { LinkTo } from "../../constants/linkTo";
import ArrowSmallIcon from 'shared/icons/ArrowSmallIcon';
import { useScrollDown } from 'shared/hooks/useScrollDown';
import { useSelector } from 'react-redux';
import { InfinityProjectsSelector } from 'shared/reducers/InfinityProjects';
import getCurrentYear from "../../helpers/getCurrentYear";
import { useHistory, useRouteMatch } from "react-router-dom";
import { MobileMenuModalSelector } from 'shared/reducers/mobileMenuOpen';
import { GeoTagModalSelector } from 'shared/reducers/geoTagsModal';
import CommdesignFooter from './CommdesignFooter';
import TeamInfo from "../TeamInfo/TeamInfo";
import AudioPlayer from "../AudioPlayer";
import { CopyLinkSwitcher } from "../AudioPlayer/components/CopyLinkSwitcher";
import { PrefixName } from 'shared/navbars/logos/styles';
import { useGetLogo } from '../navigationSystem/useGetLogo';
import { useProfile } from '@brg/auth';
import { bProfile } from '@brg/auth';

enum AnimationType {
  UP = 'slide-up',
  DOWN = 'slide-down',
  STATIC = ''
}

interface Props {
  isMobile?: boolean;
  pos?: 'flex-start' | 'center' | 'flex-end';
  area?: 'A' | 'B' | 'C';
  isWrap?: boolean;
  visible?: boolean;
}

const routesWithExtFooter = [
  '/books/project',
  '/books/book',
  '/book',
  '/books/preview',
  "/book-preview",
  '/preview',
  '/project'
]

export const CollapseAnim = keyframes`
  from {
    bottom: -1px;
  }
  to {
    bottom: -90px;
  }
`;

export const CollapseRevertAnim = keyframes`
  from {
    bottom: -90px;
  }
  to {
    bottom: -1;
  }
`;

const FooterOuterWrapper = styled.div<{ isKiiids?: boolean }>`
${p => p.isKiiids ? css`
  .footer-scrolltop-button {
    svg {
      circle {
        fill: #22156C;
      }
      path {
        fill: #CDCDCD;
      }
    }
  }
  > div {
    background: #22156C;
  }
  div {
  color:${Colors.galBlack21} !important;
    div{
      color: ${Colors.galBlack21} !important;
      >a {
      color: ${Colors.galBlack21} !important;
      }
    >span>a{
    color: ${Colors.galBlack21} !important;
    }
  }
}
  ` : css`
    min-height: 32px;
  `};
`

export const CopyRight = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: #909090;
  white-space: pre;
  margin-left: 20px;
  padding-right: calc((100vw - 1152px) / 2 - 30px);
  z-index: 9999;
  //letter-spacing: 0.04em;

  @media (max-width: 1280px) {
    padding-right: 0;
  }

  @media (max-width: 834px) {
    font-weight: 500;
    font-size: 11px;
    line-height: 13px;
    letter-spacing: 0.04em;
    // padding-right: calc(40px - 16px);
  }
  @media (max-width: 576px) {
    font-weight: 500;
    font-size: 11px;
    line-height: 13px;
    letter-spacing: 0.04em;
    // padding-right: 0;
  }
`;

const QALinkWrapper = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  right: 64px;

  @media (max-width: 940px) {
  right: 16px;
  }

  @media (max-width: 743px) {
  display: none;
  }
`;

const QAText = styled.span`
   font-family: 'Inter';
   font-style: normal;
   font-weight: 600;
   font-size: 13px;
   line-height: 16px;
   color: ${Colors.galBlack47};
   margin-right: 8px;
 `;

const QALink = styled.a`
   font-family: 'Inter';
   font-style: normal;
   font-weight: 600;
   font-size: 13px;
   line-height: 16px;
   color: ${Colors.galBlack73};
   text-decoration: none;
   &:hover {
     color: #151514;
   }
 `;

const NavItemForeignOuter = styled.div`
  @media (max-width: 1280px) {
    width: 100%;
  }
  @media (max-width: 720px) {
    width: auto;
      // animation: ${CollapseRevertAnim} 0.2s linear;
  }
  @media (max-width: 576px) {
    width: auto;
  }
`;

const DropDownLegals = styled.div<any>`
  border-radius: 3px;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
  min-width: 224px;
  z-index: 9999999;
  box-shadow: rgb(7 7 7 / 17%) 0px 1px 4px;

  & ${DropdownListItem} {
    background: ${(p) => p.isKiiids ? '#22156C' : p.theme.fixedFooter.background.color} !important;
    ${(p) => p.isKiiidsArt && 'color: #CDCDCD;'}
  }
`;

const ScrollBtnWrapper = styled(FlexBox)`
  position: absolute;
  top: -17px;
  right: 17px;
  z-index: 9997;

  @media ( max-width: 834px) {
    top: -12px;
    right: 12px;
  }

  @media ( max-width: 576px) {
    right: 10px;
  }
`;

const SupportLinkWrapper = styled(ExternalLink)`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 4px;
    align-self: stretch;
    font-family: Inter;
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px;

    ${({ theme: { teamLinkHover, app: { text } } }) => css`
      color: ${text};

     svg {
        rect {
          stroke: ${text};
        }
        path {
          fill: ${text};
        }
      }
    

    :hover {
      color: ${teamLinkHover};
      svg {
        rect {
          stroke: ${teamLinkHover};
        }
        path {
          fill: ${teamLinkHover};
        }
      }
    }
    `};

    svg {
        width: 16px;
        height: 16px;
    }
    @media (max-width: 1200px) {
      font-size: 11px;
      line-height: 13px;
      margin-left: 3px;
      svg {
        width: 12px;
        height: 12px;
      }
    }
`

const ButtonTop = styled.button`
  border-style: none;
  background: transparent;
  width: 40px;
  height: 40px;
  box-sizing: content-box;
  cursor: pointer;
  z-index: 9998;
  outline: none;

  @media ( max-width: 834px) {
    width: 24px;
    height: 24px;

    svg {
      width: 24px;
      height: 24px;
    }
  }

  @media ( max-width: 576px) {
    width: 32px;
    height: 32px;

    svg {
      width: 32px;
      height: 32px;
    }
  }

  &:focus {
    outline: none;
  }

  & svg {
    circle {
      fill: ${({ theme }) => theme.fixedFooter.icons.circle};
    }

    path {
      fill: ${({ theme }) => theme.btns.hollow.icon};
    }

    // &:active {
    //   circle {
      //     stroke: ${({ theme }) => theme.btns.hollow.borderActive};
    //   }
    // }
  }
`;

const LeftOffset = styled(FlexBox) <any>`
  padding-left: calc((100vw - 1152px - 32px) / 2);
`

function toTheTopScroll() {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}

const menuItemsMap: Record<string, { link?: string, title: string }> = {
  [AppName.deziiign]: {
    link: process.env.REACT_APP_URL_DEZIIIGN,
    title: 'deziiign'
  },
  [AppName.hsedesign]: {
    link: process.env.REACT_APP_URL_HSEDESIGN_RU,
    title: 'hsedesign'
  },
  [AppName.geograffee]: {
    link: process.env.REACT_APP_URL_GEOGRAPHY,
    title: 'geograffee'
  },
  [AppName.gallllery]: {
    link: process.env.REACT_APP_URL_GALLERY,
    title: 'gallllery'
  },
};

const menuItemsMapAgeytomesh: Record<string, { link?: string, title: string }> = {
  [AppName.deziiign]: {
    link: process.env.REACT_APP_URL_DEZIIIGN,
    title: 'deziiign'
  },
  [AppName.hsedesign]: {
    link: process.env.REACT_APP_URL_HSEDESIGN_RU,
    title: 'hsedesign'
  },
  [AppName.geograffee]: {
    link: process.env.REACT_APP_URL_GEOGRAPHY,
    title: 'geograffee'
  },
  [AppName.gallllery]: {
    link: process.env.REACT_APP_URL_GALLERY,
    title: 'gallllery'
  },
};

type PropsT = {
  className?: string;
};

const FixedFooter: FC<PropsT> = (): React.ReactElement => {
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  const [scrollDown, isPrevPos, isScrolling] = useScrollDown();
  const [slideFooter, setSlideFooter] = useState(false);
  const [animationType, setAnimationType] = useState(AnimationType.STATIC);
  const [extendedFooter, setExtendedFooter] = useState<boolean>(false)

  const modal = useModal();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [menuDropdownOpen, setMenuDropdownOpen] = useState(false);
  const isProjectsLoading = useSelector(InfinityProjectsSelector)?.isLoading;
  const isTagsModalActive = useSelector(modalControllerSelector)?.name === 'tags';
  const isMobileMenuModalActive = useSelector(MobileMenuModalSelector)?.modalIsOpen;
  const isGeoPointModal = useSelector(GeoTagModalSelector)?.modalIsOpen;
  const isProjectEdit = !!useRouteMatch('/edit');
  const isBookEdit = !!useRouteMatch("/books/book-edit/:id");
  const isMap = useRouteMatch('/map');
  const isCreatePlaceModal = !!useRouteMatch('/createLocation');
  const isCommdesignLanding = useRouteMatch("/school/commdesign/2")
  const isDvaDesign = AppTester.isDvaDesign();
  const isGalllleryArt = AppTester.isGalllleryArt();
  const isCGrave = AppTester.isCGRAVE();
  const isAdcrDafesNet = AppTester.isAdcrDafesNet();
  const isHseSpace = AppTester.isHseSpace();
  const isGreenAward = AppTester.isGreenAward();
  const isHseHH = AppTester.isHseHH();
  const isHseAnimation = AppTester.isHseAnimation();
  const isContinuumSite = AppTester.isContinuumSite();
  const isBooksGallery = AppTester.isBooksGallllery();
  const isAcademy = AppTester.isAcademy();
  const isKiiidsArt = AppTester.isKiiidsArt();

  const profile = useProfile()

  const supportLinkText = profile && (bProfile.isModer(profile) || bProfile.isStudent(profile) || bProfile.isEmployee(profile)) ? t('footer.support') : undefined

  const contextName = getCurrentContextName()

  const mainLogo = useGetLogo({
    isFooter: true,
    navDisabled: !isAcademy
  })

  const isMobile = useIsMobile();
  const is1280BP = useBreakpoint(1280);
  const is568BP = useBreakpoint(LayoutConst.screen.sm);
  const is744BP = useBreakpoint(LayoutConst.screen.s);
  const is720BP = useBreakpoint(720);
  const isS = useBreakpoint(LayoutConst.screen.s - 1);
  const is576BP = useBreakpoint(576);

  const { location } = useHistory()

  const shouldHideFooter = useMemo(
    () => (
      (isProjectEdit && is576BP) ||
      (isBookEdit && is576BP) ||
      (isMobile && isCreatePlaceModal) ||
      isTagsModalActive ||
      isMobileMenuModalActive ||
      isGeoPointModal),
    [
      isProjectEdit,
      isBookEdit,
      isCreatePlaceModal,
      isGeoPointModal,
      isMobileMenuModalActive,
      isTagsModalActive,
      isMobile,
      is576BP
    ])

  const isGeo = AppTester.isGeograffee();
  const isAgeytomesh = AppTester.isAgeytomesh();
  const isDeziiign = AppTester.isDeziiign();
  const isMediiia = AppTester.isMediiia();
  const isHSEDesign = AppTester.isHSEDesign();
  const isDafes = AppTester.isGeoDafes();
  const isSuperPuper = AppTester.isSuperPuper();
  const isCompetitions = AppTester.isCompetition();
  const isBrnd = AppTester.isBrnd();
  const isSchool = AppTester.isSchool();
  const isHseCreative = AppTester.isCreativeHSE();
  const isLMSHSECreative = AppTester.isLMSHSECreative()

  const isHSE = isHSEDesign || isSchool || isHseCreative || isHseSpace || isDafes || isAcademy || isLMSHSECreative;

  useEffect(() => {
    if (routesWithExtFooter.some((item: string) => {
      console.log('location found')
      return location.pathname.includes(item)
    })) {
      setExtendedFooter(true)
    } else {
      setExtendedFooter(false)
    }
  }, [location])

  const name = useMemo(() => {

    if (isHSE) {
      return (i18n.language === 'ru' ? 'НИУ ВШЭ' : 'HSE University');
    }

    return (i18n.language === 'ru' ? 'ООО «БРНД-РУ»' : '«BRND-RU» LLC');
  }, [i18n.language]);

  const privacyLink =
    i18n.language === 'ru' ? 'https://www.hse.ru/data_protection_regulation' : 'https://www.hse.ru/en/data_protection_regulation';

  const currentYear = useMemo(() => {
    if (isGreenAward) {
      return `2025`
    }
    if (isAdcrDafesNet) {
      return `2025`
    }
    return `2022-${getCurrentYear()}`;
  }, [])

  const legalsLink = useMemo(() => {
    if (isKiiidsArt) {
      return process.env.REACT_APP_URL_KIIIDS_ART
    }
    if (isCGrave) {
      return process.env.REACT_APP_URL_CGRAVE
    }
    if (isHSE) {
      return process.env.REACT_APP_URL_HSEDESIGN_RU
    }
    if (isAcademy) {
      return process.env.REACT_APP_URL_CREATIVE_CITY
    }
    if (isMediiia || AppTester.isPortfolio365() || isContinuumSite) {
      return window.location.origin.includes(".ru")
        ? process.env.REACT_APP_URL_MEDIIIA_COM
        : process.env.REACT_APP_URL_MEDIIIA_COM
    }
    if (isGeo) {
      return window.location.origin.includes(".ru")
        ? process.env.REACT_APP_URL_GEOGRAPHY_RU
        : process.env.REACT_APP_URL_GEOGRAPHY_COM
    }
    if (isBrnd) {
      return process.env.REACT_APP_URL_BRANDS
    }
    if (isSuperPuper) {
      return process.env.REACT_APP_SUPERPUPER_DOMAIN
    }
    if (isGalllleryArt) {
      return process.env.REACT_APP_URL_DEZIIIGN_GALLERY_ART
    }
    if (isBooksGallery) {
      return process.env.REACT_APP_URL_GALLERY
    }
    return process.env.REACT_APP_URL_DEZIIIGN;
  }, [])

  const LegalsList = useMemo(() => {
    const privacyURL = isHSE ? privacyLink : `${legalsLink}${LinkTo.privacy}`
    const legalsUrl = `${isBrnd || isHSE || isAcademy ? legalsLink : 'https://mediiia.com'}${isCGrave ? LinkTo.license : LinkTo.legals}`
    if (isHseHH) {
      return null
    }
    if (isHseAnimation) {
      return null
    }
    if (isGreenAward) {
      return null
    }
    if (isS) {
      return (
        <div style={{ display: 'flex', flexGrow: '1', justifyContent: 'flex-end' }}>
          <DropdownTooltip
            onHide={() => setDropdownOpen(false)}
            onShow={() => setDropdownOpen(true)}
            offset={[0, 15]}
            zIndex={99999}
            target={
              <FixedFooterDropdownLegals
                style={{ marginLeft: 'auto', width: 'fit-content' }}
                onClick={() => setDropdownOpen(!dropdownOpen)}
                invertIcon={dropdownOpen}>
                <div>{t('nav.more')}</div>
                <ArrowSmallIcon fill={theme.fixedFooter.dropdown.fill} />
              </FixedFooterDropdownLegals>
            }>
            <DropDownLegals isKiiids={isKiiidsArt} style={{ display: (dropdownOpen ? 'flex' : 'none') }}>
              <DropdownListItem>
                <FixedFooterLegalsItem
                  href={privacyURL}
                  target="_blank">
                  {t('legals.privacy')}
                </FixedFooterLegalsItem>
              </DropdownListItem>
              <DropdownListItem>
                <FixedFooterLegalsItem href={legalsUrl} target="_blank">
                  {t('legals.index')}
                </FixedFooterLegalsItem>
              </DropdownListItem>
              {/* {isHSEDesign && (<DropdownListItem>
                <FixedFooterLegalsItem href="https://qa.studio/" target="_blank">
                    <QALink>
                    {t('legals.qa_studio_test')} {t('legals.qa_studio')}
                    </QALink>
                </FixedFooterLegalsItem>
              </DropdownListItem>)} */}
            </DropDownLegals>
          </DropdownTooltip>
        </div>
      )
    }
    return (
      <FixedFooterLegals style={{ paddingRight: 54 }}>
        <FixedFooterLegalsItem
          href={isHSE ? privacyLink : `https://mediiia.com${LinkTo.privacy}`}
          target="_blank">
          {t('legals.privacy')}
        </FixedFooterLegalsItem>
        <FixedFooterLegalsItem href={legalsUrl} target="_blank">
          {t('legals.index')}
        </FixedFooterLegalsItem>
      </FixedFooterLegals>
    )
  }, [i18n, t, modal, isHSEDesign, legalsLink, modal])

  if (isCommdesignLanding) return <CommdesignFooter />

  const copyrightText = `© ${name} ${currentYear}`;

  const url = isHSE ? process.env.REACT_APP_URL_HSEDESIGN_RU : ''

  return (
    <div id="footer-portal">
      <FooterOuterWrapper className='footer-outer-wrapper' isKiiids={isKiiidsArt}>
        <AudioPlayer />
        {isS && <TeamInfo isFooter isDown={animationType === AnimationType.DOWN} />}
        <FixedFooterUI
          supportLinkText={supportLinkText}
          contextName={contextName}
          noMadeOnBlock={isHSEDesign}
          extendedFooter={extendedFooter}
          isDeziiign={(isDeziiign || isCompetitions) && !(isAgeytomesh || isSuperPuper || isBrnd || isMediiia)}
          isHse={isHSE}
          isMobile={isS}
          extendedFooterLogo={mainLogo}
          shouldHideScrollToTopButton={Boolean(isMap || isMobile)}
          startFooterItems={<>
            {is744BP &&
              (
                isHSE ?
                  <FixedFooterCopyRight>
                    <ExternalLink to={url}>{copyrightText}</ExternalLink> {supportLinkText && <><span style={{ marginLeft: '3px' }}>|</span>
                      <SupportLinkWrapper to={'https://t.me/+O5bv0fqTbJJkYWEy'} target='_blank'>
                        <svg className='support-link-icon' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke="#151514" />
                          <path d="M6.92032 10.2209V10.1009C6.9234 9.5438 6.97572 9.10062 7.07728 8.77131C7.18192 8.442 7.32965 8.17732 7.52046 7.97727C7.71128 7.77415 7.94364 7.58795 8.21755 7.41868C8.40529 7.30173 8.57302 7.17401 8.72075 7.03551C8.87155 6.89394 8.99004 6.73698 9.07622 6.56463C9.16239 6.3892 9.20548 6.19377 9.20548 5.97834C9.20548 5.7352 9.14854 5.52438 9.03467 5.34588C8.9208 5.16738 8.76691 5.02888 8.57302 4.9304C8.38221 4.83191 8.16831 4.78267 7.93133 4.78267C7.71282 4.78267 7.50508 4.83037 7.30811 4.92578C7.11421 5.01811 6.95264 5.15968 6.82338 5.3505C6.69719 5.53823 6.62641 5.77675 6.61102 6.06605H4.96755C4.98294 5.4813 5.12451 4.99195 5.39227 4.59801C5.6631 4.20407 6.02011 3.90862 6.46329 3.71165C6.90955 3.51468 7.40197 3.41619 7.94056 3.41619C8.52839 3.41619 9.04544 3.51929 9.4917 3.7255C9.94104 3.9317 10.2903 4.22562 10.5396 4.60724C10.792 4.9858 10.9182 5.43513 10.9182 5.95526C10.9182 6.30611 10.8613 6.62003 10.7474 6.89702C10.6366 7.17401 10.4781 7.42022 10.2719 7.63565C10.0657 7.85109 9.82101 8.04344 9.53786 8.21271C9.28857 8.3666 9.08391 8.52663 8.92387 8.69283C8.76691 8.85902 8.64996 9.05445 8.57302 9.27912C8.49916 9.50071 8.46069 9.77462 8.45761 10.1009V10.2209H6.92032ZM7.72359 13.1016C7.4466 13.1016 7.20808 13.0031 7.00803 12.8061C6.80799 12.6091 6.70796 12.3691 6.70796 12.0859C6.70796 11.8089 6.80799 11.572 7.00803 11.375C7.20808 11.178 7.4466 11.0795 7.72359 11.0795C7.9975 11.0795 8.23448 11.178 8.43453 11.375C8.63765 11.572 8.73921 11.8089 8.73921 12.0859C8.73921 12.2737 8.69151 12.4445 8.5961 12.5984C8.50377 12.7522 8.38067 12.8754 8.22678 12.9677C8.07598 13.0569 7.90825 13.1016 7.72359 13.1016Z" fill="#151514" />
                        </svg>
                        <span>{supportLinkText}</span>
                      </SupportLinkWrapper></>}
                  </FixedFooterCopyRight>
                  :
                  <a href={url}>
                    <FixedFooterCopyRight>
                      {copyrightText} | mediiia <span style={{ position: 'relative', top: '2px' }} className='made_by_media__arrow_icon'>↗</span>
                    </FixedFooterCopyRight>
                  </a>)
            }
            {is1280BP && !is744BP && <LeftOffset width="100%"><CopyLinkSwitcher /></LeftOffset>}
          </>}
          centerFooterItems={
            <>
              {!is744BP && <a href={url}><FixedFooterCopyRight>{copyrightText}</FixedFooterCopyRight></a>}
              {is1280BP && !isS && <FlexBox width="100%" offsetLeft={24}><CopyLinkSwitcher /></FlexBox>}
            </>
          }
          lastFooterItems={<>
            {!is1280BP && <CopyLinkSwitcher />}
            {!isAgeytomesh && !isDvaDesign &&
              LegalsList}

            {/* {isHSEDesign && !isHseSpace && (
            <QALinkWrapper>
            <QAText>{t('legals.qa_studio_test')}</QAText>
            <QALink
              href="https://qa.studio/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('legals.qa_studio')}
            </QALink>
          </QALinkWrapper>
          )} */}
          </>}
          shouldHideFooter={shouldHideFooter}
          animationType={animationType}
        />
      </FooterOuterWrapper>
    </div>
  );
};
export default FixedFooter;
import React, { FC, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { useTheme, css, keyframes } from 'styled-components';
import { LayoutConst, modalControllerSelector, useModal } from "core/modules";
import {
  FlexBox,
  useIsMobile,
  GridBox,
  useBreakpoint,
  DropdownListItem,
  DropdownTooltip,
  FixedFooterUI,
  FixedFooterCopyRight,
  FixedFooterLegalsItem,
  FixedFooterLegals,
  FixedFooterDropdownLegals,
  NavItemForeign,
  FixedFooterSelectedItem,
  FixedFooterSelectedItemWrapper,
  NavbarLogoName,
  Colors,
  ExternalLink
} from '@brg/ui';
import { AppTester, getCurrentAppName, AppName, getCurrentContextName } from 'supporting';
import ArrowFooterLarge from "../../icons/ArrowFooterLarge";
import { LinkTo } from "../../constants/linkTo";
import ArrowSmallIcon from 'shared/icons/ArrowSmallIcon';
import { useScrollDown } from 'shared/hooks/useScrollDown';
import { useSelector } from 'react-redux';
import { InfinityProjectsSelector } from 'shared/reducers/InfinityProjects';
import getCurrentYear from "../../helpers/getCurrentYear";
import { useHistory, useRouteMatch } from "react-router-dom";
import { MobileMenuModalSelector } from 'shared/reducers/mobileMenuOpen';
import { GeoTagModalSelector } from 'shared/reducers/geoTagsModal';
import CommdesignFooter from './CommdesignFooter';
import TeamInfo from "../TeamInfo/TeamInfo";
import AudioPlayer from "../AudioPlayer";
import { CopyLinkSwitcher } from "../AudioPlayer/components/CopyLinkSwitcher";
import { PrefixName } from 'shared/navbars/logos/styles';
import { useGetLogo } from '../navigationSystem/useGetLogo';
import { useProfile } from '@brg/auth';
import { bProfile } from '@brg/auth';

enum AnimationType {
  UP = 'slide-up',
  DOWN = 'slide-down',
  STATIC = ''
}

interface Props {
  isMobile?: boolean;
  pos?: 'flex-start' | 'center' | 'flex-end';
  area?: 'A' | 'B' | 'C';
  isWrap?: boolean;
  visible?: boolean;
}

const routesWithExtFooter = [
  '/books/project',
  '/books/book',
  '/book',
  '/books/preview',
  "/book-preview",
  '/preview',
  '/project'
]

export const CollapseAnim = keyframes`
  from {
    bottom: -1px;
  }
  to {
    bottom: -90px;
  }
`;

export const CollapseRevertAnim = keyframes`
  from {
    bottom: -90px;
  }
  to {
    bottom: -1;
  }
`;

const FooterOuterWrapper = styled.div<{ isKiiids?: boolean }>`
${p => p.isKiiids ? css`
  .footer-scrolltop-button {
    svg {
      circle {
        fill: #22156C;
      }
      path {
        fill: #CDCDCD;
      }
    }
  }
  > div {
    background: #22156C;
  }
  div {
  color:${Colors.galBlack21} !important;
    div{
      color: ${Colors.galBlack21} !important;
      >a {
      color: ${Colors.galBlack21} !important;
      }
    >span>a{
    color: ${Colors.galBlack21} !important;
    }
  }
}
  ` : css`
    min-height: 32px;
  `};
`

export const CopyRight = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: #909090;
  white-space: pre;
  margin-left: 20px;
  padding-right: calc((100vw - 1152px) / 2 - 30px);
  z-index: 9999;
  //letter-spacing: 0.04em;

  @media (max-width: 1280px) {
    padding-right: 0;
  }

  @media (max-width: 834px) {
    font-weight: 500;
    font-size: 11px;
    line-height: 13px;
    letter-spacing: 0.04em;
    // padding-right: calc(40px - 16px);
  }
  @media (max-width: 576px) {
    font-weight: 500;
    font-size: 11px;
    line-height: 13px;
    letter-spacing: 0.04em;
    // padding-right: 0;
  }
`;

const QALinkWrapper = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  right: 64px;

  @media (max-width: 940px) {
  right: 16px;
  }

  @media (max-width: 743px) {
  display: none;
  }
`;

const QAText = styled.span`
   font-family: 'Inter';
   font-style: normal;
   font-weight: 600;
   font-size: 13px;
   line-height: 16px;
   color: ${Colors.galBlack47};
   margin-right: 8px;
 `;

const QALink = styled.a`
   font-family: 'Inter';
   font-style: normal;
   font-weight: 600;
   font-size: 13px;
   line-height: 16px;
   color: ${Colors.galBlack73};
   text-decoration: none;
   &:hover {
     color: #151514;
   }
 `;

const NavItemForeignOuter = styled.div`
  @media (max-width: 1280px) {
    width: 100%;
  }
  @media (max-width: 720px) {
    width: auto;
      // animation: ${CollapseRevertAnim} 0.2s linear;
  }
  @media (max-width: 576px) {
    width: auto;
  }
`;

const DropDownLegals = styled.div<any>`
  border-radius: 3px;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
  min-width: 224px;
  z-index: 9999999;
  box-shadow: rgb(7 7 7 / 17%) 0px 1px 4px;

  & ${DropdownListItem} {
    background: ${(p) => p.isKiiids ? '#22156C' : p.theme.fixedFooter.background.color} !important;
    ${(p) => p.isKiiidsArt && 'color: #CDCDCD;'}
  }
`;

const ScrollBtnWrapper = styled(FlexBox)`
  position: absolute;
  top: -17px;
  right: 17px;
  z-index: 9997;

  @media ( max-width: 834px) {
    top: -12px;
    right: 12px;
  }

  @media ( max-width: 576px) {
    right: 10px;
  }
`;

const SupportLinkWrapper = styled(ExternalLink)`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 4px;
    align-self: stretch;
    font-family: Inter;
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px;

    ${({ theme: { teamLinkHover, app: { text } } }) => css`
      color: ${text};

     svg {
        rect {
          stroke: ${text};
        }
        path {
          fill: ${text};
        }
      }
    

    :hover {
      color: ${teamLinkHover};
      svg {
        rect {
          stroke: ${teamLinkHover};
        }
        path {
          fill: ${teamLinkHover};
        }
      }
    }
    `};

    svg {
        width: 16px;
        height: 16px;
    }
    @media (max-width: 1200px) {
      font-size: 11px;
      line-height: 13px;
      margin-left: 3px;
      svg {
        width: 12px;
        height: 12px;
      }
    }
`

const ButtonTop = styled.button`
  border-style: none;
  background: transparent;
  width: 40px;
  height: 40px;
  box-sizing: content-box;
  cursor: pointer;
  z-index: 9998;
  outline: none;

  @media ( max-width: 834px) {
    width: 24px;
    height: 24px;

    svg {
      width: 24px;
      height: 24px;
    }
  }

  @media ( max-width: 576px) {
    width: 32px;
    height: 32px;

    svg {
      width: 32px;
      height: 32px;
    }
  }

  &:focus {
    outline: none;
  }

  & svg {
    circle {
      fill: ${({ theme }) => theme.fixedFooter.icons.circle};
    }

    path {
      fill: ${({ theme }) => theme.btns.hollow.icon};
    }

    // &:active {
    //   circle {
      //     stroke: ${({ theme }) => theme.btns.hollow.borderActive};
    //   }
    // }
  }
`;

const LeftOffset = styled(FlexBox) <any>`
  padding-left: calc((100vw - 1152px - 32px) / 2);
`

function toTheTopScroll() {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}

const menuItemsMap: Record<string, { link?: string, title: string }> = {
  [AppName.deziiign]: {
    link: process.env.REACT_APP_URL_DEZIIIGN,
    title: 'deziiign'
  },
  [AppName.hsedesign]: {
    link: process.env.REACT_APP_URL_HSEDESIGN_RU,
    title: 'hsedesign'
  },
  [AppName.geograffee]: {
    link: process.env.REACT_APP_URL_GEOGRAPHY,
    title: 'geograffee'
  },
  [AppName.gallllery]: {
    link: process.env.REACT_APP_URL_GALLERY,
    title: 'gallllery'
  },
};

const menuItemsMapAgeytomesh: Record<string, { link?: string, title: string }> = {
  [AppName.deziiign]: {
    link: process.env.REACT_APP_URL_DEZIIIGN,
    title: 'deziiign'
  },
  [AppName.hsedesign]: {
    link: process.env.REACT_APP_URL_HSEDESIGN_RU,
    title: 'hsedesign'
  },
  [AppName.geograffee]: {
    link: process.env.REACT_APP_URL_GEOGRAPHY,
    title: 'geograffee'
  },
  [AppName.gallllery]: {
    link: process.env.REACT_APP_URL_GALLERY,
    title: 'gallllery'
  },
};

type PropsT = {
  className?: string;
};

const FixedFooter: FC<PropsT> = (): React.ReactElement => {
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  const [scrollDown, isPrevPos, isScrolling] = useScrollDown();
  const [slideFooter, setSlideFooter] = useState(false);
  const [animationType, setAnimationType] = useState(AnimationType.STATIC);
  const [extendedFooter, setExtendedFooter] = useState<boolean>(false)

  const modal = useModal();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [menuDropdownOpen, setMenuDropdownOpen] = useState(false);
  const isProjectsLoading = useSelector(InfinityProjectsSelector)?.isLoading;
  const isTagsModalActive = useSelector(modalControllerSelector)?.name === 'tags';
  const isMobileMenuModalActive = useSelector(MobileMenuModalSelector)?.modalIsOpen;
  const isGeoPointModal = useSelector(GeoTagModalSelector)?.modalIsOpen;
  const isProjectEdit = !!useRouteMatch('/edit');
  const isBookEdit = !!useRouteMatch("/books/book-edit/:id");
  const isMap = useRouteMatch('/map');
  const isCreatePlaceModal = !!useRouteMatch('/createLocation');
  const isCommdesignLanding = useRouteMatch("/school/commdesign/2")
  const isDvaDesign = AppTester.isDvaDesign();
  const isGalllleryArt = AppTester.isGalllleryArt();
  const isCGrave = AppTester.isCGRAVE();
  const isAdcrDafesNet = AppTester.isAdcrDafesNet();
  const isHseSpace = AppTester.isHseSpace();
  const isGreenAward = AppTester.isGreenAward();
  const isHseHH = AppTester.isHseHH();
  const isHseAnimation = AppTester.isHseAnimation();
  const isContinuumSite = AppTester.isContinuumSite();
  const isBooksGallery = AppTester.isBooksGallllery();
  const isAcademy = AppTester.isAcademy();
  const isKiiidsArt = AppTester.isKiiidsArt();

  const profile = useProfile()

  const supportLinkText = profile && (bProfile.isModer(profile) || bProfile.isStudent(profile) || bProfile.isEmployee(profile)) ? t('footer.support') : undefined

  const contextName = getCurrentContextName()

  const mainLogo = useGetLogo({
    isFooter: true,
    navDisabled: !isAcademy
  })

  const isMobile = useIsMobile();
  const is1280BP = useBreakpoint(1280);
  const is568BP = useBreakpoint(LayoutConst.screen.sm);
  const is744BP = useBreakpoint(LayoutConst.screen.s);
  const is720BP = useBreakpoint(720);
  const isS = useBreakpoint(LayoutConst.screen.s - 1);
  const is576BP = useBreakpoint(576);

  const { location } = useHistory()

  const shouldHideFooter = useMemo(
    () => (
      (isProjectEdit && is576BP) ||
      (isBookEdit && is576BP) ||
      (isMobile && isCreatePlaceModal) ||
      isTagsModalActive ||
      isMobileMenuModalActive ||
      isGeoPointModal),
    [
      isProjectEdit,
      isBookEdit,
      isCreatePlaceModal,
      isGeoPointModal,
      isMobileMenuModalActive,
      isTagsModalActive,
      isMobile,
      is576BP
    ])

  const isGeo = AppTester.isGeograffee();
  const isAgeytomesh = AppTester.isAgeytomesh();
  const isDeziiign = AppTester.isDeziiign();
  const isMediiia = AppTester.isMediiia();
  const isHSEDesign = AppTester.isHSEDesign();
  const isDafes = AppTester.isGeoDafes();
  const isSuperPuper = AppTester.isSuperPuper();
  const isCompetitions = AppTester.isCompetition();
  const isBrnd = AppTester.isBrnd();
  const isSchool = AppTester.isSchool();
  const isHseCreative = AppTester.isCreativeHSE();
  const isLMSHSECreative = AppTester.isLMSHSECreative()

  const isHSE = isHSEDesign || isSchool || isHseCreative || isHseSpace || isDafes || isAcademy || isLMSHSECreative;

  useEffect(() => {
    if (routesWithExtFooter.some((item: string) => {
      console.log('location found')
      return location.pathname.includes(item)
    })) {
      setExtendedFooter(true)
    } else {
      setExtendedFooter(false)
    }
  }, [location])

  const name = useMemo(() => {

    if (isHSE) {
      return (i18n.language === 'ru' ? 'НИУ ВШЭ' : 'HSE University');
    }

    return (i18n.language === 'ru' ? 'ООО «БРНД-РУ»' : '«BRND-RU» LLC');
  }, [i18n.language]);

  const privacyLink =
    i18n.language === 'ru' ? 'https://www.hse.ru/data_protection_regulation' : 'https://www.hse.ru/en/data_protection_regulation';

  const currentYear = useMemo(() => {
    if (isGreenAward) {
      return `2025`
    }
    if (isAdcrDafesNet) {
      return `2025`
    }
    return `2022-${getCurrentYear()}`;
  }, [])

  const legalsLink = useMemo(() => {
    if (isKiiidsArt) {
      return process.env.REACT_APP_URL_KIIIDS_ART
    }
    if (isCGrave) {
      return process.env.REACT_APP_URL_CGRAVE
    }
    if (isHSE) {
      return process.env.REACT_APP_URL_HSEDESIGN_RU
    }
    if (isAcademy) {
      return process.env.REACT_APP_URL_CREATIVE_CITY
    }
    if (isMediiia || AppTester.isPortfolio365() || isContinuumSite) {
      return window.location.origin.includes(".ru")
        ? process.env.REACT_APP_URL_MEDIIIA_COM
        : process.env.REACT_APP_URL_MEDIIIA_COM
    }
    if (isGeo) {
      return window.location.origin.includes(".ru")
        ? process.env.REACT_APP_URL_GEOGRAPHY_RU
        : process.env.REACT_APP_URL_GEOGRAPHY_COM
    }
    if (isBrnd) {
      return process.env.REACT_APP_URL_BRANDS
    }
    if (isSuperPuper) {
      return process.env.REACT_APP_SUPERPUPER_DOMAIN
    }
    if (isGalllleryArt) {
      return process.env.REACT_APP_URL_DEZIIIGN_GALLERY_ART
    }
    if (isBooksGallery) {
      return process.env.REACT_APP_URL_GALLERY
    }
    return process.env.REACT_APP_URL_DEZIIIGN;
  }, [])

  const LegalsList = useMemo(() => {
    const privacyURL = isHSE ? privacyLink : `${legalsLink}${LinkTo.privacy}`
    const legalsUrl = `${isBrnd || isHSE || isAcademy ? legalsLink : 'https://mediiia.com'}${isCGrave ? LinkTo.license : LinkTo.legals}`
    if (isHseHH) {
      return null
    }
    if (isHseAnimation) {
      return null
    }
    if (isGreenAward) {
      return null
    }
    if (isS) {
      return (
        <div style={{ display: 'flex', flexGrow: '1', justifyContent: 'flex-end' }}>
          <DropdownTooltip
            onHide={() => setDropdownOpen(false)}
            onShow={() => setDropdownOpen(true)}
            offset={[0, 15]}
            zIndex={99999}
            target={
              <FixedFooterDropdownLegals
                style={{ marginLeft: 'auto', width: 'fit-content' }}
                onClick={() => setDropdownOpen(!dropdownOpen)}
                invertIcon={dropdownOpen}>
                <div>{t('nav.more')}</div>
                <ArrowSmallIcon fill={theme.fixedFooter.dropdown.fill} />
              </FixedFooterDropdownLegals>
            }>
            <DropDownLegals isKiiids={isKiiidsArt} style={{ display: (dropdownOpen ? 'flex' : 'none') }}>
              <DropdownListItem>
                <FixedFooterLegalsItem
                  href={privacyURL}
                  target="_blank">
                  {t('legals.privacy')}
                </FixedFooterLegalsItem>
              </DropdownListItem>
              <DropdownListItem>
                <FixedFooterLegalsItem href={legalsUrl} target="_blank">
                  {t('legals.index')}
                </FixedFooterLegalsItem>
              </DropdownListItem>
              {/* {isHSEDesign && (<DropdownListItem>
                <FixedFooterLegalsItem href="https://qa.studio/" target="_blank">
                    <QALink>
                    {t('legals.qa_studio_test')} {t('legals.qa_studio')}
                    </QALink>
                </FixedFooterLegalsItem>
              </DropdownListItem>)} */}
            </DropDownLegals>
          </DropdownTooltip>
        </div>
      )
    }
    return (
      <FixedFooterLegals style={{ paddingRight: 54 }}>
        <FixedFooterLegalsItem
          href={isHSE ? privacyLink : `https://mediiia.com${LinkTo.privacy}`}
          target="_blank">
          {t('legals.privacy')}
        </FixedFooterLegalsItem>
        <FixedFooterLegalsItem href={legalsUrl} target="_blank">
          {t('legals.index')}
        </FixedFooterLegalsItem>
      </FixedFooterLegals>
    )
  }, [i18n, t, modal, isHSEDesign, legalsLink, modal])

  if (isCommdesignLanding) return <CommdesignFooter />

  const copyrightText = `© ${name} ${currentYear}`;

  const url = isHSE ? process.env.REACT_APP_URL_HSEDESIGN_RU : ''

  return (
    <div id="footer-portal">
      <FooterOuterWrapper className='footer-outer-wrapper' isKiiids={isKiiidsArt}>
        <AudioPlayer />
        {isS && <TeamInfo isFooter isDown={animationType === AnimationType.DOWN} />}
        <FixedFooterUI
          supportLinkText={supportLinkText}
          contextName={contextName}
          noMadeOnBlock={isHSEDesign}
          extendedFooter={extendedFooter}
          isDeziiign={(isDeziiign || isCompetitions) && !(isAgeytomesh || isSuperPuper || isBrnd || isMediiia)}
          isHse={isHSE}
          isMobile={isS}
          extendedFooterLogo={mainLogo}
          shouldHideScrollToTopButton={Boolean(isMap || isMobile)}
          startFooterItems={<>
            {is744BP &&
              (
                isHSE ?
                  <FixedFooterCopyRight>
                    <ExternalLink to={url}>{copyrightText}</ExternalLink> {supportLinkText && <><span style={{ marginLeft: '3px' }}>|</span>
                      <SupportLinkWrapper to={'https://t.me/+O5bv0fqTbJJkYWEy'} target='_blank'>
                        <svg className='support-link-icon' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke="#151514" />
                          <path d="M6.92032 10.2209V10.1009C6.9234 9.5438 6.97572 9.10062 7.07728 8.77131C7.18192 8.442 7.32965 8.17732 7.52046 7.97727C7.71128 7.77415 7.94364 7.58795 8.21755 7.41868C8.40529 7.30173 8.57302 7.17401 8.72075 7.03551C8.87155 6.89394 8.99004 6.73698 9.07622 6.56463C9.16239 6.3892 9.20548 6.19377 9.20548 5.97834C9.20548 5.7352 9.14854 5.52438 9.03467 5.34588C8.9208 5.16738 8.76691 5.02888 8.57302 4.9304C8.38221 4.83191 8.16831 4.78267 7.93133 4.78267C7.71282 4.78267 7.50508 4.83037 7.30811 4.92578C7.11421 5.01811 6.95264 5.15968 6.82338 5.3505C6.69719 5.53823 6.62641 5.77675 6.61102 6.06605H4.96755C4.98294 5.4813 5.12451 4.99195 5.39227 4.59801C5.6631 4.20407 6.02011 3.90862 6.46329 3.71165C6.90955 3.51468 7.40197 3.41619 7.94056 3.41619C8.52839 3.41619 9.04544 3.51929 9.4917 3.7255C9.94104 3.9317 10.2903 4.22562 10.5396 4.60724C10.792 4.9858 10.9182 5.43513 10.9182 5.95526C10.9182 6.30611 10.8613 6.62003 10.7474 6.89702C10.6366 7.17401 10.4781 7.42022 10.2719 7.63565C10.0657 7.85109 9.82101 8.04344 9.53786 8.21271C9.28857 8.3666 9.08391 8.52663 8.92387 8.69283C8.76691 8.85902 8.64996 9.05445 8.57302 9.27912C8.49916 9.50071 8.46069 9.77462 8.45761 10.1009V10.2209H6.92032ZM7.72359 13.1016C7.4466 13.1016 7.20808 13.0031 7.00803 12.8061C6.80799 12.6091 6.70796 12.3691 6.70796 12.0859C6.70796 11.8089 6.80799 11.572 7.00803 11.375C7.20808 11.178 7.4466 11.0795 7.72359 11.0795C7.9975 11.0795 8.23448 11.178 8.43453 11.375C8.63765 11.572 8.73921 11.8089 8.73921 12.0859C8.73921 12.2737 8.69151 12.4445 8.5961 12.5984C8.50377 12.7522 8.38067 12.8754 8.22678 12.9677C8.07598 13.0569 7.90825 13.1016 7.72359 13.1016Z" fill="#151514" />
                        </svg>
                        <span>{supportLinkText}</span>
                      </SupportLinkWrapper></>}
                  </FixedFooterCopyRight>
                  :
                  <a href={url}>
                    <FixedFooterCopyRight>
                      {copyrightText} | mediiia <span style={{ position: 'relative', top: '2px' }} className='made_by_media__arrow_icon'>↗</span>
                    </FixedFooterCopyRight>
                  </a>)
            }
            {is1280BP && !is744BP && <LeftOffset width="100%"><CopyLinkSwitcher /></LeftOffset>}
          </>}
          centerFooterItems={
            <>
              {!is744BP && <a href={url}><FixedFooterCopyRight>{copyrightText}</FixedFooterCopyRight></a>}
              {is1280BP && !isS && <FlexBox width="100%" offsetLeft={24}><CopyLinkSwitcher /></FlexBox>}
            </>
          }
          lastFooterItems={<>
            {!is1280BP && <CopyLinkSwitcher />}
            {!isAgeytomesh && !isDvaDesign &&
              LegalsList}

            {/* {isHSEDesign && !isHseSpace && (
            <QALinkWrapper>
            <QAText>{t('legals.qa_studio_test')}</QAText>
            <QALink
              href="https://qa.studio/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('legals.qa_studio')}
            </QALink>
          </QALinkWrapper>
          )} */}
          </>}
          shouldHideFooter={shouldHideFooter}
          animationType={animationType}
        />
      </FooterOuterWrapper>
    </div>
  );
};
export default FixedFooter;
